import moment from 'moment-timezone'

export const eventTypeOptions = [
  {
    actions: [],
    hint: 'This notification will be sent <strong>immediately</strong> when the Docket Entry is created.',
    text: 'Created',
    value: 'created',
  },
  {
    actions: [],
    description: 'This Notification is sent <strong>before</strong> the Docket Entry Start Date/Time',
    hint: 'This notification will be sent [interval] [unit] <strong>before</strong> the Docket Entry start date/time',
    text: 'Reminder ',
    value: 'reminder',
    needs_interval: true,
  },
  {
    actions: ['Appointment'],
    hint: 'This notification will be sent <strong>immediately</strong> when an Appointment is Canceled',
    text: 'Canceled',
    value: 'canceled',
  },
  {
    actions: ['Appointment'],
    hint: 'This notification will be sent <strong>immediately</strong> when an Appointment is Rescheduled',
    text: 'Rescheduled',
    value: 'rescheduled',
  },
  {
    actions: ['Appointment'],
    hint: 'This notification will be sent <strong>immediately</strong> when an Attendee is set as No Show',
    text: 'No Show',
    value: 'no-show',
  },
  {
    actions: [],
    description: 'This Notification is sent <strong>after</strong> the Docket Entry Start Date/Time',
    hint: 'This notification will be sent [interval] [unit] <strong>after</strong> the Docket Entry start date/time',
    text: 'Notification',
    value: 'notification',
    needs_interval: true,
  },
]

export const intervalUnitOptions = [
  {
    text: 'Day(s)',
    value: 'days',
  },
  {
    text: 'Hour(s)',
    value: 'hours',
  },
  {
    text: 'Minute(s)',
    value: 'minutes',
  },
  {
    text: 'Second(s)',
    value: 'seconds',
  },
]

export const templateTags = [
  {
    label: 'Docket Entry Type',
    description: 'The name of the Docket Entry Type',
    actionTypes: ['Appointment', 'Event', 'Note', 'Task'],
    tag: 'DocketEntryType',
    entity: 'DocketEntryType',
    property: 'name',
    exampleValue: 'Example Meeting',
  },
  {
    label: 'Party Name',
    description: 'First and last names of the Party',
    actionTypes: ['Appointment', 'Event', 'Note', 'Task'],
    tag: 'PartyName',
    entity: 'Party',
    property: 'name',
    exampleValue: 'John Doe',
  },
  {
    label: 'Primary Attorney',
    description: 'Name of the Legal Case Primary Attorney',
    actionTypes: ['Appointment', 'Event', 'Note', 'Task'],
    tag: 'PrimaryAttorneyName',
    entity: 'PrimaryAttorney',
    property: 'display_name',
    exampleValue: 'Joseph Law',
  },
  {
    label: 'Scheduled Date',
    description: 'Date the entry is scheduled for',
    actionTypes: ['Appointment', 'Event', 'Note', 'Task'],
    tag: 'ScheduledDate',
    entity: 'DocketEntry',
    property: docketEntry => moment.tz(docketEntry.action_date, docketEntry.timezone).format('dddd, LL'),
    exampleValue: 'Wednesday, June 4, 2014',
  },
  {
    label: 'Scheduled Date and Time',
    description: 'Date and time the action starts at',
    actionTypes: ['Appointment', 'Event'],
    tag: 'ScheduledDateTime',
    entity: 'DocketEntry',
    property: docketEntry => {
      if (!(docketEntry?.action_date && docketEntry?.event_time_start && docketEntry?.timezone)) return null

      return moment.
        tz(`${docketEntry.action_date} ${docketEntry.event_time_start}`, 'YYYY-MM-DD LT', docketEntry.timezone).
        format('LLLL zz')
    },
    exampleValue: 'Wednesday, June 4, 2014 10:00 AM PDT',
  },
  {
    label: 'Scheduled Start Time',
    description: 'Time the action starts at.',
    actionTypes: ['Appointment', 'Event'],
    tag: 'ScheduledStartTime',
    entity: 'DocketEntry',
    property: docketEntry => moment(docketEntry.event_time_start, 'LT').format('LT'),
    exampleValue: '10:00 AM',
  },
  {
    label: 'Scheduled End Time',
    description: 'Time the action ends at',
    actionTypes: ['Appointment', 'Event'],
    tag: 'ScheduledEndTime',
    entity: 'DocketEntry',
    property: docketEntry => moment(docketEntry.event_time_end, 'LT').format('LT'),
    exampleValue: '11:30 PM',
  },
  {
    label: 'Timezone',
    description: 'The timezone in which the dates are set',
    actionTypes: ['Appointment', 'Event'],
    tag: 'Timezone',
    entity: 'DocketEntry',
    property: docketEntry => {
      if (!docketEntry?.action_date) return null
      return moment.tz(docketEntry.action_date, docketEntry.timezone).format('zz')
    },
    exampleValue: 'PDT',
  },
  {
    label: 'Location',
    description: 'Where the action will take place at',
    actionTypes: ['Appointment'],
    tag: 'Location',
    entity: 'DocketEntry',
    property: 'appointment_location',
    exampleValue: 'ACME Offices, Room Z',
  },
  {
    label: 'Old Scheduled Date',
    description: 'Date the entry was previously scheduled for',
    actionTypes: ['Appointment'],
    tag: 'OldScheduledDate',
    entity: 'OldDocketEntry',
    property: docketEntry => moment.tz(docketEntry.action_date, docketEntry.timezone).format('LL'),
    exampleValue: 'Wednesday, June 4, 2014',
  },
  {
    label: 'Old Scheduled Date and Time',
    description: 'Date and time the entry was previoysly scheduled for',
    actionTypes: ['Appointment'],
    tag: 'OldScheduledDateTime',
    entity: 'OldDocketEntry',
    property: docketEntry => {
      if (!(docketEntry?.action_date && docketEntry?.event_time_start && docketEntry?.timezone)) return null

      return moment.
        tz(`${docketEntry.action_date} ${docketEntry.event_time_start}`, 'YYYY-MM-DD LT', docketEntry.timezone).
        format('LLLL zz')
    },
    exampleValue: 'Wednesday, June 4, 2014 1:00 PM PDT',
  },
  {
    label: 'Old Scheduled Start Time',
    description: 'Date the entry was previously set to start at',
    actionTypes: ['Appointment'],
    tag: 'OldScheduledStartTime',
    entity: 'OldDocketEntry',
    property: docketEntry => moment(docketEntry.event_time_start, 'LT').format('LT'),
    exampleValue: '1:00 PM',
  },
  {
    label: 'Old Scheduled End Time',
    description: 'Date the entry was previously set to end at',
    actionTypes: ['Appointment'],
    tag: 'OldScheduledEndTime',
    entity: 'OldDocketEntry',
    property: docketEntry => moment(docketEntry.event_time_end, 'LT').format('LT'),
    exampleValue: '2:30 PM',
  },
  {
    label: 'Old Timezone',
    description: 'The timezone in which old dates where set',
    actionTypes: ['Appointment'],
    tag: 'OldTimezone',
    entity: 'OldDocketEntry',
    property: docketEntry => {
      if (!docketEntry?.action_date) return null
      return moment.tz(docketEntry.action_date, docketEntry.timezone).format('zz')
    },
    exampleValue: 'PDT',
  },
]

export const extractTagsFromTemplate = template => {
  return ((template || '').match(/\[[^\]]+\]/g) || []).reduce((res, val) => {
    const tag = val.substring(1, val.length - 1)
    if (!res.includes(tag)) res.push(tag)
    return res
  }, [])
}

export const getTemplateEntityPropertyValue = (entity, property) => {
  const propType = typeof property
  let value = ''

  if (propType === 'function') value = property(entity)
  if (propType === 'string') value = entity[property]

  return value
}

export const parseTemplate = (template, entities) => {
  let parsed = template || ''

  for (const tdef of templateTags) {
    const tag = `[${tdef.tag}]`

    const entity = entities[tdef.entity]
    if (!entity) continue

    const value = getTemplateEntityPropertyValue(entity, tdef.property)
    if (value) parsed = parsed.replaceAll(tag, value)
  }

  return parsed
}

export const parseExampleTemplate = template => {
  let parsed = template || ''

  for (const tdef of templateTags) {
    const tag = `[${tdef.tag}]`

    parsed = parsed.replaceAll(tag, tdef.exampleValue || tag)
  }

  return parsed
}
